
export const VERSION = '5.8.9'; // Update this manually on each release


